import React, { forwardRef, useState } from 'react';

import { Input, InputContainer, InputError } from './styles';

const InputSimple = forwardRef((props, ref) => {
    const {
        value,
        placeholder,
        showText,
        errorMessage,
        className,
        isNotValid,
        inputType,
        onChange,
        onPaste,
        onBlur,
        onFocus,
        name,
        ...rest
    } = props;

    const onFocusHandler = e => {
        onFocus(e);
        setIsFocused(true);
    };

    const onBlurHandler = e => {
        onBlur(e);
        setIsFocused(false);
    };

    const [isFocused, setIsFocused] = useState(false);

    return (
        <InputContainer className={className}>
            <Input
                value={value}
                showText={showText}
                isNotValid={isNotValid}
                type={inputType}
                onChange={onChange}
                onPaste={onPaste}
                onBlur={onBlurHandler}
                placeholder={isFocused ? '' : placeholder}
                onFocus={onFocusHandler}
                name={name}
                ref={ref}
                selectorForTest='input'
                data-test='input'
                {...rest}
            />
            {
                isNotValid && <InputError data-test='error'>{errorMessage}</InputError>
            }
        </InputContainer>
    );
});

InputSimple.defaultProps = {
    value: '',
    name: '',
    placeholder: '',
    showText: true,
    errorMessage: '',
    className: '',
    isNotValid: false,
    inputType: '',
    isValid: true,
    onChange: () => null,
    onPaste: () => null,
    onFocus: () => null,
    onBlur: () => null,
};

InputSimple.displayName = 'InputSimple';
export default InputSimple;
